module.exports = {
    infoList: {
        infoListTitle: '个人信息清单及SDK共享清单',
        topTips: '为提供更好的产品或服务，并保障系统安全稳定运行，我们可能会收集你的以下个人信息:',
        userInfoTitle: '用户身份信息',
        userInfoTips: '为支持您创建账号及登录、验证身份，我们将在您 完善账号信息、进行身份验证，收集使用您的手机 号码、电子邮箱、身份信息及其他基本信息。',
        sdkTitle: '第三方 SDK所需信息和具体场景、用途',
        sdkContentArr: [
            {
                // 标题
                title: 'com.aliyun(阿里云;阿里push;阿里推送)SDK',
                // 使用目的
                objective: '用于作为统计分析时使用的维度，崩溃日志的上报及分析，用于拉取指定设备上的日志并实现日志上报及缓存功能',
                // 收集个人信息类型
                collectInfoType: 'IMEI  、AndroidID 、操作系统、设备型号，运营商信息，IP、陀螺仪传感器、加速度传感器、重力传感器信息',
                // 官网链接
                url: 'https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112071754_83380.html',
            },
            {

                title: '支付宝SDK',
                objective: '帮助用户在应用内使用支付宝',
                collectInfoType: '设备信息（包括IMEI/IMSI、SIM卡序列号/MAC地址、android_id) 、网络信息、位置信息',
                url: 'https://docs.open.alipay.com/54',
            },
            {

                title: '友盟+SDK',
                objective: '通过捕捉应用运行过程中的错误信息，上报给后台用来分析和优化应用程序',
                collectInfoType: '日志信息（包括:第三方开发者自定义日志、Logcat日志以及APP崩溃堆栈信息)、设备信息（ICCID/IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM卡IMSI/地理位置等）',
                url: 'https://www.umeng.com/page/policy',
            },
            {

                title: '微信开放平台SDK',
                objective: '微信支付功能、微信登录功能',
                collectInfoType: '设备信息、网络信息',
                url: 'https://open.weixin.qq.com/',
            },
            {

                title: 'MobTech SDK',
                objective: '实现APP内的推送功能',
                collectInfoType: '位置信息、网络信息、设备信息(OAID/IMSI/IMEI/应用列表/基站信息/系统运营信息）',
                url: 'www.mob.com/about/policy',
            },
            {

                title: '华为云 SDK',
                objective: '实现APP的云存储录像播放',
                collectInfoType: '网络信息',
                url: 'https://www.huaweicloud.com/declaration/sa_prp.html',
            },
            {

                title: '小米推送',
                objective: '当自建推送服务不可达时,小米手机用户将通过MIUI系统推送消息',
                collectInfoType: '设备标识信息（包括IMEI/OAID(适用于Android Q以上系统)、IMEI MD5/MEIDMD5、Android ID、VAID、AAID，以及您的MID (适用于MIUI系统)）、设备型号、网络类型、设备存储、设备运行进程信息、应用版本、SDK版本、设置信息（包括是否屏蔽通知栏、是否设置锁屏弹出消息）、推送服务的应用信息(包名、版本号、应用名称、首次安装时间、上次完成更新的时间)',
                url: 'https://dev.mi.com/console/doc/detail?pld=1822',
            },
            {

                title: '华为SDK',
                objective: '推送服务、广告服务',
                collectInfoType: '设备及应用信息(如设备名称、设备识别符、硬件型号、操作系统版本、应用程序版本、软件识别码、设备及应用设置(如地区/语言/时区/字体)等）、网络信息',
                url: 'https://consumer.huawei.com/cn/privacy/privacy-policy/',
            },
            {

                title: 'OPPO推送',
                objective: '当自建推送服务不可达时，OPPO手机用户将通过OPPO系统推送消息',
                collectInfoType: '设备信息 (如IMEl号，SerialNumber，IMSI，User ID，Android lD，Google Advertising ID, 手机Region设置, 设备型号，手机电量，手机操作系统版本及语言)、应用信息(如APP包名及版本号，运行状态)、推送SDK版本号、网络相关信息(如IP或域名连接结果，当前网络类型)、消息发送结果，通知栏状态(如通知栏权限、用户点击行为）, 锁屏状态(如是否锁屏，是否允许锁屏通知)',
                url: 'https://open.oppomobile.com/wiki/ do-10288',
            },
            {

                title: 'VIVO推送',
                objective: '当自建推送服务不可达时，vivo手机用户将通过vivo系统推送消息',
                collectInfoType: '网络信息',
                url: 'https://dev.vivo.com.cn/documentCenter/doc/365',
            },
            {

                title: '百度推送SDK',
                objective: '实现APP内的推送功能',
                collectInfoType: '位置信息、网络信息、设备信息(OAID/IMSI/IMEI/应用列表/基站信息/系统运营信息）、陀螺仪传感器、加速度传感器、重力传感器信息',
                url: 'http://push.baidu.com/doc/guide/baidu_legal',
            },
            {

                title: '网易易盾SDK',
                objective: '行为式验证码',
                collectInfoType: '设备唯一识别码（设备序列号、AndroidID、IDFV、IDFA）、设备品牌、设备名称、设备型号及设备系统类型、详细设置及版本信息',
                url: 'https://dun.163.com/clause/privacy',
            },
            {

                title: 'Mediatom SDK',
                objective: '投放广告',
                collectInfoType: '设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、IMEI、IMSI、ICCID、GAID、MEID、IDFA、IDFV、AndroidID、OAID、手机系统重启时间、设备的MAC地址、User Agent、加速度传感器、陀螺仪传感器',
                url: 'https://www.mediatom.cn/compdocs/detail/?id=42'
            },
            {

                title: '穿山甲SDK',
                objective: '广告投放及广告反作弊',
                collectInfoType: '【双端】设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息等基础信息;【仅Android】AndroidID【仅iOS】手机系统重启时间、磁盘总空间、系统总内存空间、CPU数目等基础信息、IDFV【双端】无线网SSID名称、WiFi路由器MAC地址、设备的MAC地址（如为iOS端，则仅适用于IOS3200以下版本）【仅Android】设备标识符（IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、设备序列号build_serial，具体字段因软硬件版本不同而存在差异）【仅iOS】设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异）官网',
                url: 'https://www.csjplatform.com/privacy/partner',
            },
            {

                title: '优量汇SDK',
                objective: '广告投放',
                collectInfoType: '粗略位置信息【仅 Android】基站、附近的WIFI、连接的WIFI第三方开发者可以选择是否向本SDK提供如下信息：【双端】精确位置信息,设备/网络/系统信息【双端】设备制造商、品牌、设备型号、操作系统版本、屏幕分辨率、屏幕方向、屏幕DPI、IP地址、时区、网络类型、运营商【仅Android】磁力、加速度、重力、陀螺仪传感器,【仅iOS】设备名称、系统启动时间、系统语言、磁盘空间、设备姿态、压力传感器等基础信息,标识符【仅Android】OAID第三方开发者可以选择是否授权本SDK收集如下信息：【仅Android】 IMEI、Android_ID【仅iOS】IDFV、 IDFA,应用信息【双端】宿主应用的包名、版本号【仅Android】 宿主应用的进程名称、运行状态、可疑行为 ,第三方开发者可以选择是否授权本SDK收集如下信息：【双端】应用安装信息,使用数据【双端】如产品交互数据、广告数据（如展示、点击、转化广告数据）诊断数据【双端】如崩溃数据、性能数据',
                url: 'https://e.qq.com/dev/help_detail.html?cid=2005&pid=5983',
            },
            {

                title: 'MMA 中国广告监测通用SDK',
                objective: '广告投放',
                collectInfoType: '设备标识信息（OAID、IMEI、Android ID等）、网络信息（连接的WIFI、MAC地址等',
                url: 'https://mmachina.cn/sdk-privacy/',
            },
            {

                title: '图灵盾风险识别SDK',
                objective: '广告投放',
                collectInfoType: '硬件序列号、网络状态、系统设置、系统属性、设备型号、操作系统、IP地址、运营商信息、标识符如OAID、IDFA、IDFV等;由第三方开发者根据实际情况决定是否采集并传输给SDK，SDK采取去标识、加密等方式进行处理',
                url: '安卓链接：https://privacy.qq.com/document/preview/5331f064a91a47eb93993fdacb91c8f7    IOS链接：https://privacy.qq.com/document/preview/71da09a0402c439fac73f7b97f38f328 ',
            },
            {

                title: '快手联盟SDK',
                objective: '广告投放',
                collectInfoType: '<strong>基础信息：</strong>设备品牌、设备型号、软件系统版本、存储信息、运营商信息、设备时区、设备语言、网络信息基等基础信息;<strong>设备标识：</strong>IMEI、MEID、OAID、AndroidId、IMSI、ICCID;<strong>位置信息：</strong>IP地址、MAC地址、GPS位置信息、基站信息、WIFI信息;<strong>应用信息：</strong>应用安装列表、应用的进程名称、运行状态;<strong>其他信息：</strong>传感器信息、sim卡激活信息;<strong>获取权限：</strong>【Android】必选权限访问互联网、网络状态、手机WiFi状态、安装应用; 可选权限获取设备标识、获取MAC地址【iOS】网络权限、设备信息（IDFA）、获取粗略位置',
                url: 'https://u.kuaishou.com/home/help/detail/1337/1220',
            },
            {

                title: '百度联盟SDK',
                objective: '广告投放',
                collectInfoType: '<strong>设备信息：</strong>必选信息：设备品牌、型号、软件系统版本、分辨率、网络信号强度、磁盘总空间、系统内存空间、屏幕宽高，屏幕像素密度，系统版本号，设备厂商，设备型号，手机运营商、SIM卡信息、手机重启信息、手机系统更新时间、手机系统创建时间、IDFA（仅iOS端采集）、OAID等基础信息;<strong>可选信息</strong>IMEI（仅Andriod端采集）；传感器信息（使用摇一摇等创新交互广告）；网络状态（判断网络状态、提供不同类型广告）;<strong>开发者应用信息：</strong>必选信息：应用包名、应用签名、应用前后台状态、运行进程信息;<strong>位置信息：</strong>可选信息：位置;<strong>广告信息：</strong>必选信息：操作记录、点击、展示、转化等交互数据;<strong>性能数据：</strong>必选信息：崩溃数据、性能数据 ',
                url: 'https://union.baidu.com/bqt/#/legal/policies',
            },
            {

                title: '趣盟SDK',
                objective: '广告投放',
                collectInfoType: '<strong>设备信息：</strong>【Android】设备品牌、型号、软件系统版本、分辨率、网络状态、加速度传感器、重力传感器等基础信息、设备的MAC地址、蓝牙地址、设备标识符（IMEI、AndroidID、OAID、IMSI、ICCID、MEID，具体字段因软硬件版本不同而存在差异）;<strong>应用信息：</strong>开发者应用名、应用包名、版本号、应用前后台状态、应用安装列表等信息;<strong>其他信息：</strong>运营商信息、设备时区、设备语言',
                url: 'https://docs.jietuhb.com/android_sdk/qu-privacy-agreement.html ',
            },
            {

                title: '融合SDK',
                objective: '广告投放',
                collectInfoType: '<strong>设备信息：</strong>设备品牌、型号、操作系统版本信息、设备标识符（如IMEI、AndroidID、OAID、IMSI、ICCID、GAID、MEID、IDFV、IDFA，具体字段因软硬件版本不同而存在差异）等基础信息;<strong>应用信息：</strong>开发者应用名、应用包名、版本号等信息;<strong>其他信息：</strong>运营商信息、设备时区、设备地理位置、网络设备硬件地址（MAC地址）、IP 地址、WLAN接入点（如SSID，BSSID）、蓝牙（Bluetooth）、基站、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志。',
                url: 'https://www.csjplatform.com/supportcenter/5879',
            },
            {

                title: 'Google SDK',
                objective: 'Google登录功能',
                collectInfoType: '网络信息',
                url: 'https://policies.google.com/privacy?hl=zh-CN',
            },
            {

                title: '动心广告SDK',
                objective: '提供广告流量统计相关服务',
                collectInfoType: '设备标识信息（包括IMEI、IMSI、Android ID）：用于识别手机信息便于运营数据精准、设备型号（手机型号）、网络类型（移动还是WIFI网络）、设备存储(用于下载安装类的广告)、应用版本(APP版本)、应用信息（包名、版本号、应用名称）、陀螺仪传感器、加速度传感器、重力传感器信息',
                url: '',
            },
        ],
        userInfoContentArr: [
            {
                title: '手机号码',
                // 使用目的
                objective: '创建账号;身份验证',
                // 使用场景
                scene: '用户首次注册时，使用手机号登录时',
                // 信息内容
                content: '查看详情',
            },
            {
                title: '电子邮箱',
                // 使用目的
                objective: '创建账号;身份验证',
                // 使用场景
                scene: '用户首次注册时，使用邮件方式验证 身份时',
                // 信息内容
                content: '查看详情',
            },
            {
                title: '第三方账号信息',
                // 使用目的
                objective: '登录账号',
                // 使用场景
                scene: '使用微信、谷歌账号登录时',
                // 信息内容
                content: '查看详情',
            },
            {
                title: '账号及密码',
                // 使用目的
                objective: '创建账号、保护账号安全',
                // 使用场景
                scene: '创建账号与修改账号密码时',
                // 信息内容
                content: '查看详情',
            },

        ]
    }
}

